import type { FC } from 'react';
import React from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import { FiltersIcon } from '@motorway/mw-highway-code';

import texts from '../../VehicleListV2.texts.json';

import styles from './AllFiltersButton.module.scss';

const LocalT = new MDText(texts);

interface AllFiltersButtonProps {
	activeFilterCount: number;
	onClick: () => void;
}

export const AllFiltersButton: FC<AllFiltersButtonProps> = ({ activeFilterCount, onClick }) => (
	<button
		data-all-filters
		className={cx(styles.allFiltersChip, {
			[styles.hasFilters]: activeFilterCount > 0,
		})}
		data-testid="filter-chip-allFilters"
		onClick={onClick}
		type="button"
	>
		<FiltersIcon size="small" />
		<span>{LocalT.translate('filterBar.allFilters')}</span>
		{activeFilterCount > 0 && <span className={styles.allFiltersCount}>+{activeFilterCount}</span>}
	</button>
);
